import DocumentTextIcon from '@heroicons/react/outline/esm/DocumentTextIcon.js'
import { clsx } from 'clsx'

import { Space } from '@tribeplatform/gql-client/types'
import { analyticsNumberFormatter } from '@tribeplatform/react-components/Analytics/utils'
import { T } from '@tribeplatform/react-components/i18n'

import { StaticField } from '../../Views/types.js'

interface Props {
  space: Space
  highlighted: boolean
  stretchX: string
  variant: StaticField['settings']['buttonVariant']
}
export const PostsCount = ({
  space,
  highlighted,
  stretchX,
  variant,
}: Props) => {
  const postsCount = space?.postsCount

  if (variant === 'icon') {
    return (
      <div
        className={clsx(
          'flex space-s-2 text-content-subdued items-center empty:hidden',
          highlighted && 'ring-2 rounded-sm ring-offset-surface ring-focused',
          stretchX,
        )}
      >
        <DocumentTextIcon className="h-5 w-5" />
        <span>{analyticsNumberFormatter(postsCount ?? '0')}</span>
      </div>
    )
  }

  return (
    <div
      className={clsx(
        'flex space-s-2 text-content-subdued items-center empty:hidden',
        highlighted && 'ring-2 rounded-sm ring-offset-surface ring-focused',
        stretchX,
      )}
    >
      {variant === 'iconText' && <DocumentTextIcon className="h-5 w-5" />}
      <span>
        <T
          defaultMessage="{posts_count, plural, =0 {No posts} =1 {{posts_count_text} post} other {{posts_count_text} posts}}"
          id="SpacesListBlock.PostsCount"
          values={{
            posts_count: postsCount ?? 0,
            posts_count_text: analyticsNumberFormatter(postsCount ?? '0'),
          }}
        />
      </span>
    </div>
  )
}
